import { useContext, useEffect, useRef, useState } from "react";
import Prince from "../../Components/Prince";
import TopHeader from "../../Components/TopHeader";
import DateFormatter from "../Common/CustomDatePicker";
import Loader from "../../assets/img/loader.gif";
import TablePagination from "../Common/newTablePagination";
import B2CBulkStatusChanges from "./b2cbulkStatusChanges";
import B2CBulkCaseAssign from "./b2cbulkCaseAssign";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import B2CExportModal from "./b2cexportModal";
import * as caseService from "../../Services/caseService";
import { DataContext } from "../../context/DataContext";
import { toast } from "react-toastify";

export const B2CCases = () => {
  const [loader, setLoader] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [clearDate, setClearDate] = useState(false);
  const [activeTab, setActiveTab] = useState("New");
  const [activeSubTab, setActiveSubTab] = useState("Tech");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const totalPages = Math.ceil(totalCount / pageSize);
  const [selectedLeadSource, setSelectedLeadSource] = useState([]);
  const [selectedCases, setSelectedCases] = useState([]);
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const b2cbulkstatusChangeRef = useRef(null);
  const B2CBulkCaseAssignModalRef = useRef(null);
  const casesexportModalRef = useRef(null);
  const handlePageSize = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };
  const navigate = useNavigate();
  const [caseTypeOptions, setCaseTypeOptions] = useState([]);
  const [selectedCaseTypes, setSelectedCaseTypes] = useState([]);
  const [caseSubTypeOptions, setCaseSubTypeOptions] = useState([]);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [caseData, setCaseData] = useState([]);
  const [allCounts, setAllCounts] = useState({});
  const result = useContext(DataContext);
  const [employeeData, setEmployee] = useState({});
  const [startingCaseId, setStartingCaseId] = useState(null);

  useEffect(() => {
    setEmployee(result.employeeData);
  }, [result.employeeData]);

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = caseData.map((item) => item.id);
      setSelectedCases(allIds);
    } else {
      setSelectedCases([]);
    }
  };

  const customSelectStyles = {
    control: (base) => ({
      ...base,
      minHeight: "40px",
      borderRadius: "5px",
    }),
  };

  const handleTabClick = (value) => {
    if (loader) return;

    setSelectedCases([]);
    setCurrentPage(1);
    setActiveTab(value);

    // if (value === "In Progress") {
    //   setActiveSubTab("Pending on Tech");
    // } else {
    //   setActiveSubTab("");
    // }
    if (value === "In Progress") {
      const firstSubTab =
        Number(employeeData?.userType) === 1 ||
        Number(employeeData?.userType) === 2
          ? allInProgressSubTabs[0]
          : allInProgressSubTabs.find((tab) =>
              tab.departments.includes(employeeData?.department?.trim()),
            );

      setActiveSubTab(firstSubTab?.value || "");
    } else {
      setActiveSubTab("");
    }
  };

  // react-select styles

  const tabs = [
    { label: "New", value: "New", countKey: "newCount" },
    { label: "In Progress", value: "In Progress", countKey: "inProcessCount" },
    {
      label: "Yet to close",
      value: "Yet to close",
      countKey: "yetToCloseCount",
    },
    { label: "Close", value: "Closed", countKey: "closedCount" },
    // ...(Number(employeeData?.userType) === 1 ||
    //     Number(employeeData?.userType) === 2
    //     ? [
    //         {
    //             label: "Close",
    //             value: "Closed",
    //             countKey: "closedCount"
    //         }
    //     ]
    //     : []),
    { label: "All", value: "All", countKey: "allCaseCount" },
  ];

  // const inProgressSubTabs = [
  //     { label: "Pending on Tech", value: "Pending on Tech", countKey: "pendingOnTechCount" },
  //     { label: "Pending on First mile ops", value: "Pending on First mile ops", countKey: "pendingOnFirstMileOpsCount" },
  //     { label: "Pending on Last mile Ops", value: "Pending on Last mile Ops", countKey: "pendingOnLastMileOpsCount" },
  //     { label: "Pending on weight team", value: "Pending on weight team", countKey: "pendingOnWeightteamCount" },
  //     { label: "Pending on sales", value: "Pending on sales", countKey: "pendingOnSalesCount" },
  //     { label: "Pending on legal", value: "Pending on legal", countKey: "pendingOnLegalCount" },
  //     { label: "Pending on client", value: "Pending on client", countKey: "pendingOnClientCount" }
  // ];

   const allInProgressSubTabs = [
    {
      label: "Tech",
      value: "Tech",
      countKey: "pendingOnTech",
      departments: ["Tech Support"],
    },
    {
      label: "First Mile Ops",
      value: "First Mile Ops",
      countKey: "pendingOnFirstMileOps",
      departments: ["Fist Mile Ops"],
    },
    {
      label: "Last Mile Ops",
      value: "Last Mile Ops",
      countKey: "pendingOnLastMileOps",
      departments: ["Last Mile Ops"],
    },
    {
      label: "Weight Team",
      value: "Weight Team",
      countKey: "pendingOnWeightTeam",
      departments: ["Weight Management Ops"],
    },
    {
      label: "Sales",
      value: "Sales",
      countKey: "pendingOnSales",
      departments: ["Sales"],
    },
    {
      label: "Legal",
      value: "Legal",
      countKey: "pendingOnLegal",
      departments: ["Management"],
    },
    {
      label: "KAM",
      value: "KAM",
      countKey: "pendingOnKAM",
      departments: ["KAM"],
    },
    {
      label: "Support",
      value: "Support",
      countKey: "pendingOnSupport",
      departments: ["Support"],
    },
  ];

  const inProgressSubTabs =
    Number(employeeData?.userType) === 1 || Number(employeeData?.userType) === 2
      ? allInProgressSubTabs
      : allInProgressSubTabs.filter((tab) =>
          tab.departments.includes(employeeData?.department?.trim()),
        );

  const [filters, setFilters] = useState({
    id: "",
    status: "",
    masterStatus: "",

    caseType: [],
    caseSubType: [],
    customerId: [],
    kamId: [],

    search: "",
    from: "",
    to: "",
    isTat: false,
  });

  const handleApplyFilter = () => {
    setCurrentPage(1);
    getCaseData(filters, 1);
  };

  const handleClearFilter = () => {
    const clearedFilters = {
      id: "",
      status: "",
      masterStatus: "",
      caseType: [],
      caseSubType: [],
      customerId: [],
      kamId: [],
      search: "",
      from: "",
      to: "",
      isTat: false,
    };

    setFilters(clearedFilters);
    setSelectedCaseTypes([]);
    setClearDate((prev) => !prev);

    setCurrentPage(1);

    getCaseData(clearedFilters, 1);
  };

  useEffect(() => {
    getCaseData();
  }, [activeTab, activeSubTab, currentPage, pageSize]);

  //   useEffect(() => {
  //     if (activeTab === "In Progress" && employeeData?.department) {
  //       const matchedSubTab = allInProgressSubTabs.find((subTab) =>
  //         subTab.departments.includes(employeeData.department),
  //       );

  //       if (matchedSubTab) {
  //         setActiveSubTab(matchedSubTab.value);
  //       }
  //     }
  //   }, [activeTab, employeeData]);

  useEffect(() => {
     if (activeTab !== "In Progress") return;
 
     if (
       Number(employeeData?.userType) === 1 ||
       Number(employeeData?.userType) === 2
     ) {
       setActiveSubTab(allInProgressSubTabs[0]?.value || "");
       return;
     }
 
     const matchedSubTab = allInProgressSubTabs.find((subTab) =>
       subTab.departments.includes(employeeData?.department?.trim()),
     );
 
     if (matchedSubTab) {
       setActiveSubTab(matchedSubTab.value);
     }
   }, [activeTab, employeeData]);

  useEffect(() => {
    getCaseType();
    getallEmployee();
    // getCaseSubType();
  }, []);

  const handleStartCase = async (caseId) => {
    try {
      setStartingCaseId(caseId);

      const response = await caseService.startCaseB2C(caseId);

      if (response?.data?.status === "success") {
        toast.success("Case started successfully");

        // list refresh
        getCaseData();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to start case");
    } finally {
      setStartingCaseId(null);
    }
  };

  const getCaseData = (customFilters = filters, customPage = currentPage) => {
    setLoader(true);

    const payload = {
      id: customFilters.id,

      // status: activeTab,
      status: activeTab === "In Progress" ? activeSubTab : activeTab,

      masterStatus: customFilters.masterStatus,

      caseType: (customFilters.caseType || []).map((i) => i.value).join(","),

      caseSubType: (customFilters.caseSubType || [])
        .map((i) => i.value)
        .join(","),

      customerId: (customFilters.customerId || [])
        .map((i) => i.value)
        .join(","),

      kamId: (customFilters.kamId || []).map((i) => i.value).join(","),

      search: customFilters.search,

      from: customFilters.from,

      to: customFilters.to,

      isTat: customFilters.isTat,

      // page: currentPage,
      page: customPage,

      pageSize: pageSize,
    };

    caseService
      .b2ccaselist(payload)
      .then((res) => {
        if (res?.data?.status === "success") {
          setCaseData(res.data.data || []);

          setTotalCount(res.data.totalCount || 0);

          setAllCounts(res.data.allCounts || {});
        }
      })
      .catch((error) => {
        console.log("B2B Case List Error:", error);

        setCaseData([]);
        setTotalCount(0);
        setAllCounts({});
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getCaseType = () => {
    caseService
      .casetype()
      .then((res) => {
        const data = res?.data?.data || [];

        const formattedOptions = data.map((item) => ({
          label: item?.name?.trim(),
          value: item?.id,
        }));

        setCaseTypeOptions(formattedOptions);
      })

      .catch((error) => {
        // console.log(
        //     "CASE TYPE ERROR",
        //     error
        // );
      });
  };

  const getCaseSubType = (ids) => {
    if (!ids || ids.length === 0) {
      setCaseSubTypeOptions([]);
      return;
    }

    // console.log("CASE TYPE IDS:", ids);

    caseService
      .casesubtype(ids)
      .then((res) => {
        const data = res?.data?.data || [];

        const formattedOptions = data.map((item) => ({
          label: item?.name?.trim(),
          value: item?.id,
        }));

        setCaseSubTypeOptions(formattedOptions);
      })
      .catch((error) => {
        console.log("CASE SUB TYPE ERROR:", error);
        setCaseSubTypeOptions([]);
      });
  };

  const getallEmployee = () => {
    caseService
      .allemployee()
      .then((res) => {
        const data = res?.data?.data || [];

        const formattedOptions = data.map((item) => ({
          label: item?.name,
          value: item?.id,
        }));

        setEmployeeOptions(formattedOptions);
      })
      .catch((error) => {
        // console.log("Employee error", error);
        setEmployeeOptions([]);
      });
  };

  return (
    <div className="page">
      <TopHeader />
      <Prince />
      <div className="main-content pt-0">
        <div className="container-fluid">
          <div className="d-flex justify-content-between align-items-center my-3">
            <h4>B2C Cases</h4>
          </div>

          {/* filter card  */}

          <div className="card border-0 shadow-sm rounded-4">
            <div
              className="card-header bg-white border-0 px-3 py-3"
              style={{ borderBottom: "1px solid #f1f1f1" }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                <div className="d-flex align-items-center gap-2">
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "40px",
                      height: "40px",
                      background: "#e7f1ff",
                    }}
                  >
                    <i className="fa fa-filter text-primary small"></i>
                  </div>

                  <div>
                    <h6 className="mb-0 fw-bold">Cases Filters</h6>

                    <small className="text-muted">Filter CRM Cases</small>
                  </div>
                </div>
                <button
                  className="btn btn-sm btn-light rounded-pill px-3 shadow-sm"
                  onClick={() => setShowFilters(!showFilters)}
                >
                  <i
                    className={`fa me-1 ${
                      showFilters ? "fa-chevron-up" : "fa-chevron-down"
                    }`}
                  ></i>

                  {showFilters ? "Hide" : "Show"}
                </button>
              </div>
            </div>

            {showFilters && (
              <div className="card-body p-3">
                <div className="row g-3">
                  <div className="col-12 col-md-3">
                    <label className="form-label small fw-semibold mb-1">
                      Search
                    </label>

                    <div className="input-group input-group-sm">
                      <span className="input-group-text bg-white">
                        <i className="fa fa-search text-muted"></i>
                      </span>

                      <input
                        type="text"
                        className="form-control shadow-none"
                        style={{ height: "40px" }}
                        placeholder="Search by id, companyId, mob no, email"
                        value={filters.search}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            search: e.target.value,
                          }))
                        }
                      />
                    </div>
                  </div>

                  <div className="col-12 col-md-3">
                    <DateFormatter
                      label="Date"
                      placeholder="Select Date"
                      fromKey="from"
                      toKey="to"
                      clearDate={clearDate}
                      setDateForApi={(date) =>
                        setFilters((prev) => ({
                          ...prev,
                          ...date,
                        }))
                      }
                    />
                  </div>

                  <div className="col-12 col-md-3">
                    <label className="form-label small fw-semibold mb-1">
                      Case Type
                    </label>

                    <Select
                      isMulti
                      classNamePrefix="react-select"
                      options={caseTypeOptions}
                      value={caseTypeOptions.filter((item) =>
                        selectedCaseTypes.includes(Number(item.value)),
                      )}
                      onChange={(selected) => {
                        const selectedOptions = selected || [];

                        const ids = selectedOptions.map((item) =>
                          Number(item.value),
                        );

                        setSelectedCaseTypes(ids);

                        setFilters((prev) => ({
                          ...prev,
                          caseType: selectedOptions,
                          caseSubType: [],
                        }));

                        getCaseSubType(ids);
                      }}
                      placeholder="Select"
                    />
                  </div>

                  <div className="col-12 col-md-3">
                    <label className="form-label small fw-semibold mb-1">
                      Case SubType
                    </label>

                    <Select
                      isMulti
                      classNamePrefix="react-select"
                      options={caseSubTypeOptions}
                      value={filters.caseSubType}
                      onChange={(selected) => {
                        setFilters((prev) => ({
                          ...prev,
                          caseSubType: selected || [],
                        }));
                      }}
                      placeholder="Select"
                    />
                  </div>

                  <div className="col-12 col-md-3">
                    <label className="form-label small fw-semibold mb-1">
                      Employee
                    </label>

                    <Select
                      isMulti
                      classNamePrefix="react-select"
                      options={employeeOptions}
                      value={filters.kamId}
                      onChange={(selected) => {
                        setFilters((prev) => ({
                          ...prev,
                          kamId: selected || [],
                        }));
                      }}
                      placeholder="Select"
                    />
                  </div>

                  <div className="col-12 col-md-3 d-flex align-items-end">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        id="caseTat"
                        checked={filters.isTat}
                        onChange={(e) =>
                          setFilters((prev) => ({
                            ...prev,
                            isTat: e.target.checked,
                          }))
                        }
                      />

                      <label
                        className="form-check-label small fw-semibold"
                        htmlFor="caseTat"
                      >
                        Turnaround Time (TAT) in a Case
                      </label>
                    </div>
                  </div>
                </div>

                <div className="d-flex justify-content-end gap-2 mt-4 flex-wrap">
                  <button
                    className="btn btn-sm btn-primary rounded-pill px-3 shadow-sm"
                    onClick={handleApplyFilter}
                  >
                    <i className="fa fa-filter me-1"></i>
                    Apply
                  </button>

                  <button
                    className="btn btn-sm btn-light border rounded-pill px-3"
                    onClick={handleClearFilter}
                  >
                    Clear
                  </button>
                </div>
              </div>
            )}
          </div>

          <div className="card shadow-sm mt-3 position-relative">
            {loader && (
              <div className="loading-overlay">
                <img
                  src={Loader}
                  alt="Loading..."
                  // style={{
                  //     width: "120px",
                  //     height: "120px",
                  //     objectFit: "contain",
                  // }}
                />
              </div>
            )}

            <div className="card-body">
              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-3 mb-3">
                <div className="d-flex align-items-center gap-2 flex-nowrap overflow-auto">
                  {/* <button className="btn btn-sm btn-primary rounded-pill">
                                        Total:
                                    </button> */}

                  {selectedCases.length > 0 && (
                    <button className="btn btn-sm btn-light rounded-pill">
                      Selected: {selectedCases.length}
                    </button>
                  )}
                </div>

                <div className="d-flex flex-wrap flex-md-nowrap align-items-center gap-2">
                  {(activeTab === "In Progress" ||
                    (activeTab === "Yet to close" &&
                      Number(employeeData?.userType) !== 0) ||
                    (activeTab === "Closed" &&
                      (Number(employeeData?.userType) === 1 ||
                        Number(employeeData?.userType) === 2))) && (
                    <button
                      className="btn btn-sm rounded-pill btn-warning text-nowrap"
                      disabled={selectedCases.length === 0}
                      onClick={() => b2cbulkstatusChangeRef.current?.toggle(selectedCases)}
                    >
                      Bulk Status Changes
                    </button>
                  )}

                  {(Number(employeeData?.userType) === 1 ||
                    Number(employeeData?.userType) === 2) &&
                     activeTab !== "Closed" &&
                    (
                    <button
                      className="btn btn-sm rounded-pill btn-danger text-nowrap"
                      disabled={selectedCases.length === 0}
                      onClick={() =>
                        B2CBulkCaseAssignModalRef.current?.toggle(selectedCases)
                      }
                    >
                      Bulk Case Assign
                    </button>
                  )}

                  <button
                    className="btn btn-sm rounded-pill btn-primary  text-nowrap"
                    onClick={() => casesexportModalRef.current?.toggle()}
                  >
                    <i className="fa fa-download me-1"></i>
                    Export
                  </button>
                </div>
              </div>

              <hr />

              <div>
                {/* Main Tabs */}
                <div className="d-flex flex-wrap gap-2">
                  {tabs.map((tab) => (
                    <button
                      key={tab.value}
                      onClick={() => handleTabClick(tab.value)}
                      className={`btn btn-sm ${
                        activeTab === tab.value
                          ? "btn-primary"
                          : "btn-light border"
                      }`}
                    >
                      {tab.label}
                      <span>( {allCounts?.[tab.countKey] ?? 0})</span>
                      {/* <span className="ms-1">
                                                ({totalCount ?? 0})
                                            </span> */}
                    </button>
                  ))}
                </div>

                {/* Sub Tabs */}
                {activeTab === "In Progress" && (
                  <div className="d-flex flex-wrap gap-2 mt-3">
                    {inProgressSubTabs.map((subTab) => (
                      <button
                        key={subTab.value}
                        onClick={() => setActiveSubTab(subTab.value)}
                        className={`btn btn-sm ${
                          activeSubTab === subTab.value
                            ? "btn-primary"
                            : "btn-light border"
                        }`}
                      >
                        {subTab.label}

                        <span>({allCounts?.[subTab.countKey] ?? 0})</span>
                      </button>
                    ))}
                  </div>
                )}
              </div>

              <div
                className="table-responsive mt-3 rounded-4 shadow-sm border"
                style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}
              >
                <table
                  className="table align-middle mb-0"
                  style={{ minWidth: "1200px" }}
                >
                  <thead style={{ background: "#f8fafc" }}>
                    <tr className="text-center text-uppercase small text-muted">
                      <th
                        className="align-middle border-end"
                        style={{ minWidth: "60px" }}
                      >
                        <input
                          type="checkbox"
                          onChange={handleSelectAll}
                          checked={
                            caseData.length > 0 &&
                            caseData.every((item) =>
                              selectedCases.includes(item.id),
                            )
                          }
                        />
                      </th>

                      <th className="border-end fw-bold">ID</th>
                      <th className="border-end fw-bold">Case Timeline</th>
                      <th className="border-end fw-bold">
                        Case Classification
                      </th>
                      <th className="border-end fw-bold">Client Detail</th>
                      <th className="border-end fw-bold">Case Details</th>
                      <th className="border-end fw-bold">Assigned To</th>
                      {/* <th className="border-end fw-bold">Actions</th> */}
                      {!(
                        activeTab === "Closed" &&
                        Number(employeeData?.userType) === 0
                      ) && <th className="border-end fw-bold">Actions</th>}
                    </tr>
                  </thead>

                  <tbody>
                    {caseData && caseData.length > 0 ? (
                      caseData.map((item) => (
                        <tr key={item.id} className="border-top">
                          {/* Checkbox */}
                          <td className="text-center border-end align-middle">
                            <input
                              type="checkbox"
                              checked={selectedCases.includes(item.id)}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setSelectedCases((prev) =>
                                    prev.includes(item.id)
                                      ? prev
                                      : [...prev, item.id],
                                  );
                                } else {
                                  setSelectedCases((prev) =>
                                    prev.filter((id) => id !== item.id),
                                  );
                                }
                              }}
                            />
                          </td>

                          {/* Case ID */}
                          <td className="border-end text-center align-middle">
                            <div className="fw-bold text-primary fs-6">
                              ID-{item.id}
                            </div>

                            <small className="text-muted">Case ID</small>
                          </td>

                          {/* Date / Ageing / TAT */}
                          <td className="border-end">
                            <div className="small d-flex flex-column gap-1">
                              <div>
                                <span className="fw-semibold">Date:</span>{" "}
                                {item.createdAt
                                  ? new Date(item.createdAt).toLocaleDateString(
                                      "en-IN",
                                    )
                                  : "N/A"}
                              </div>

                              <div>
                                <span className="fw-semibold">Ageing:</span>{" "}
                                {item.daysPaased ?? "N/A"}
                              </div>

                              <div>
                                <span className="fw-semibold">TAT:</span>{" "}
                                {item.caseTat ?? "N/A"}
                              </div>
                            </div>
                          </td>

                          {/* Category */}
                          <td className="border-end">
                            <div className="small d-flex flex-column gap-1">
                              <div>
                                <span className="fw-semibold">Category:</span>{" "}
                                {item.caseTypeName ?? "N/A"}
                              </div>

                              <div>
                                <span className="fw-semibold">
                                  Sub-Category:
                                </span>{" "}
                                {item.caseSubTypeName ?? "N/A"}
                              </div>
                            </div>
                          </td>

                          {/* Customer */}
                          <td className="border-end">
                            <div className="small d-flex flex-column gap-1">
                              <div>
                                <span className="fw-semibold">Name:</span>{" "}
                                {item.customer?.primaryContactName || "N/A"}
                              </div>

                              <div>
                                <span className="fw-semibold">Company:</span>{" "}
                                {item.customer?.companyName || "N/A"}
                              </div>

                              {/* <div className="fw-semibold text-dark">
                                                                {item.customer?.companyName ||
                                                                    item.customer?.primaryContactName ||
                                                                    "N/A"}
                                                            </div> */}

                              <div>
                                <i className="fa fa-envelope text-muted me-1"></i>

                                {item.customer?.emailId || "N/A"}
                              </div>

                              <div>
                                <i className="fa fa-phone text-muted me-1"></i>

                                {item.customer?.mobileNumber || "N/A"}
                              </div>
                            </div>
                          </td>

                          {/* AWB */}
                          <td className="border-end">
                            <div className="small d-flex flex-column gap-1">
                              <div>
                                <span className="fw-semibold">AWB NO:</span>{" "}
                                {item.awbNo?.length > 0
                                  ? item.awbNo
                                      .map((awb) => awb.awbNo)
                                      .filter(Boolean)
                                      .join(", ")
                                  : "N/A"}
                              </div>
                            </div>
                          </td>

                          {/* Assigned Employee */}
                          <td className="border-end">
                            <div className="small d-flex flex-column gap-1">
                              {item.EmployeeCasesM?.length > 0
                                ? item.EmployeeCasesM.map((empCase) =>
                                    empCase.employee
                                      ? `${empCase.employee.firstName || ""} ${empCase.employee.lastName || ""}`.trim()
                                      : null,
                                  )
                                    .filter(Boolean)
                                    .join(", ")
                                : "Not Assigned"}
                            </div>
                          </td>

                          {/* Actions */}
                          {!(
                            activeTab === "Closed" &&
                            Number(employeeData?.userType) === 0
                          ) && (
                            <td className="text-center align-middle">
                              <div className="d-flex justify-content-center gap-2">
                                  {activeTab === "New" && (
                                  // <button
                                  //   type="button"
                                  //   className="btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                  //   style={{
                                  //     width: "32px",
                                  //     height: "32px",
                                  //     fontSize: "12px",
                                  //   }}
                                  //   title="Start"
                                  //   onClick={() => handleStartCase(item.id)}
                                  //   disabled={startingCaseId === item.id}
                                  // >
                                  //   {startingCaseId === item.id ? (
                                  //     <span
                                  //       className="spinner-border spinner-border-sm"
                                  //       role="status"
                                  //       aria-hidden="true"
                                  //     ></span>
                                  //   ) : (
                                  //     <i className="fa fa-play"></i>
                                  //   )}
                                  // </button>

                                  <button
                                    type="button"
                                    className="btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      fontSize: "12px",
                                      background: "transparent",
                                      border: "1px solid #aaa",
                                      padding: 0,
                                    }}
                                    title="Start"
                                    onClick={() => handleStartCase(item.id)}
                                    disabled={startingCaseId === item.id}
                                  >
                                    {startingCaseId === item.id ? (
                                      <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                    ) : (
                                      <i
                                        className="fa fa-play"
                                        style={{ color: "#198754" }}
                                      ></i>
                                    )}
                                  </button>
                                )}

                                <div className="d-flex align-items-center gap-2">
                                  {/* Activity */}
                                  <button
                                    type="button"
                                    className="btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "40px",
                                      height: "40px",
                                      fontSize: "14px",
                                      background: "transparent",
                                      border: "1px solid #aaa",
                                      // color: "#555",
                                      padding: 0,
                                    }}
                                    title="Activity"
                                    onClick={() => {
                                      navigate(
                                        `/b2c/cases/activity/${item.id}`,
                                        {
                                          state: {
                                            caseId: item.id,
                                            previousTab: activeTab,
                                            filters,
                                          },
                                        },
                                      );
                                    }}
                                  >
                                    <i
                                      className="fa fa-clock-o"
                                      style={{ color: "#f0ad4e" }}
                                    ></i>
                                  </button>

                                  {/* Assign */}
                                  {(Number(employeeData?.userType) === 1 ||
                                    Number(employeeData?.userType) === 2) &&
                                    activeTab !== "Closed" && (
                                      <button
                                        type="button"
                                        className="btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                          fontSize: "14px",
                                          background: "transparent",
                                          border: "1px solid #aaa",
                                          // color: "#555",
                                          padding: 0,
                                        }}
                                        title="Assign"
                                        onClick={() => {
                                          B2CBulkCaseAssignModalRef.current?.toggle(
                                            item.id,
                                          );
                                        }}
                                      >
                                        <i
                                          className="fa fa-user-plus"
                                          style={{ color: "#0d6efd" }}
                                        ></i>
                                      </button>
                                    )}

                                  {/* Status */}
                                  {(activeTab === "In Progress" ||
                                    (activeTab === "Yet to close" &&
                                      Number(employeeData?.userType) !== 0) ||
                                    (activeTab === "Closed" &&
                                      (Number(employeeData?.userType) === 1 ||
                                        Number(employeeData?.userType) ===
                                          2))) && (
                                    <button
                                      type="button"
                                      className="btn-sm rounded-circle d-flex align-items-center justify-content-center"
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        fontSize: "14px",
                                        background: "transparent",
                                        border: "1px solid #aaa",
                                        // color: "#555",
                                        padding: 0,
                                      }}
                                      title="Status"
                                      onClick={() => {
                                          b2cbulkstatusChangeRef.current?.toggle(
                                          item.id,
                                        );
                                      }}
                                    >
                                      <i
                                        className="fa fa-exchange-alt"
                                        style={{ color: "#198754" }}
                                      ></i>
                                    </button>
                                  )}
                                </div>
                              </div>
                            </td>
                          )}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center py-5">
                          <div className="text-muted">
                            {/* <i className="fa fa-folder-open fa-2x mb-2"></i> */}

                            <div className="fw-semibold">
                              No Cases Available
                            </div>

                            <small>
                              No cases found for the selected filters.
                            </small>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {!loader && (
                <TablePagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  pageSize={pageSize}
                  handlePageChange={handlePageChange}
                  handlePageSize={handlePageSize}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <B2CBulkStatusChanges
        ref={b2cbulkstatusChangeRef}
        selectedCases={selectedCases}
        setSelectedCases={setSelectedCases}
        getCaseData={getCaseData}
      />
      <B2CBulkCaseAssign
        ref={B2CBulkCaseAssignModalRef}
        selectedCases={selectedCases}
        setSelectedCases={setSelectedCases}
        getCaseData={getCaseData}
      />
      <B2CExportModal
        ref={casesexportModalRef}
        filters={filters}
        page={currentPage}
        // pageSize={pageSize}
        status={activeTab}
      />

      <div className="mt-4 w-100 text-center">
        <div className="row mx-0 justify-content-center">
          <div className="col-12 px-0">
            <span className="d-block">
              Copyright © 2024 <a href="/">FSHIP</a>. Developed by{" "}
              <a href="http://fship.in/">FSHIP</a>. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
